import { useEffect, useState } from 'react';
// @mui
import { Typography, Box, Button, Divider } from '@mui/material';
// components
import CustomBreadcrumbs from 'src/components/custom-breadcrumbs';
import { paths } from 'src/routes/paths';
import Iconify from 'src/components/iconify';
import ModuleFeatureList from './featurecost-table-body';
import ModuleFeaturesCreate from './module-features-create-modal';
import { useBoolean } from 'src/hooks/use-boolean';
import { deleteRequest, getRequest } from 'src/services';
import { endpoints } from 'src/utils/axios';
import { enqueueSnackbar } from 'notistack';
import { LoadingScreen } from 'src/components/loading-screen';

const ModuleFeaturesMain = () => {
  const add = useBoolean();
  const [ tableData, setTableData ] = useState([]);
  const [ loading, setLoading ] = useState(false);
  const [ currentItem, setCurrentItem ] = useState(null);

  useEffect(() => {
    getAdminpackagesModules();
  }, []);
  const getAdminpackagesModules = async () => {
    setLoading(true)
    const data = await getRequest(`${endpoints.admin_dashboard.packages_plans.module_features.get_list}`);
    if (data) {
      setTableData(data);
    }
    setLoading(false)
  };



  const deleteCallBack = () => {
    console.log("deleteCallBack")
  }
  const handleDeleteRows = async (index, id) => {
    try {
      setLoading(true)
      const response = await deleteRequest(
        `${endpoints.admin_dashboard.packages_plans.module_features.delete}/${id}`, deleteCallBack
      );
      if (response) {
        enqueueSnackbar({
          variant: 'success',
          message: response?.metadata?.message || 'Deleted successfully!',
        });

        const updatedData = [ ...tableData ];
        updatedData.splice(index, 1);
        setTableData(updatedData);
        setLoading(false)
      }
    } catch (error) {
      setLoading(false)
      console.error('Delete error:', error);
    }
  };

  const handleEdit = (moduleData) => {
    setCurrentItem(moduleData);
    add.onTrue();
  };

  return (<>
    { loading ?
      <Box
        sx={ {
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '60vh',

        } }
      >
        <LoadingScreen />
      </Box>
      :
      <>
        <Box>
          <Box sx={ { mb: 2 } }>
            <CustomBreadcrumbs
              heading="Product Packages/Plan"
              links={ [ { name: '', href: paths.dashboard.root } ] }
              action={
                <Button
                  onClick={ () => add.onTrue() }
                  variant="contained"
                  startIcon={ <Iconify icon="mingcute:add-line" /> }
                >
                  Create
                </Button>
              }
              sx={ {
                mb: { xs: 3, md: 2 },
              } }
            />
            <Typography variant="h4" fontWeight="bold" color="green">
              Module and Features
            </Typography>
          </Box>
          { tableData?.length > 0 ? (
            tableData.map((module, index) => (
              <>
                <ModuleFeatureList
                  moduleData={ module }
                  onEdit={ () => handleEdit(module) }
                  onDelete={ handleDeleteRows }
                  index={ index }
                />
                <Divider />
              </>
            ))
          ) : (
            <Box
              sx={ {
                padding: "20px",
                textAlign: "center",
                backgroundColor: "#f5f5f5",
                borderRadius: "8px",
                boxShadow: "0px 2px 5px rgba(0,0,0,0.1)",
                marginTop: "10px",
              } }
            >
              No Data Available
            </Box>
          ) }

        </Box>
        {/* // create mdoal */ }
        <ModuleFeaturesCreate
          open={ add.value }
          onClose={ () => {
            add.onFalse();
            setCurrentItem(null);
          } }
          currentItem={ currentItem }
          setTableData={ setTableData }
        />
      </>
    }
  </>
  );
};
export default ModuleFeaturesMain;